import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCfYyVAyPs7eKNFjnD6elbelG6vvpdq6cg",
  authDomain: "my.qr-shirt.de",
  projectId: "qr-shirt-443515",
  storageBucket: "qr-shirt-443515.firebasestorage.app",
  messagingSenderId: "1088765801243",
  appId: "1:1088765801243:web:d474704d66a7b9ada5d9be",
  measurementId: "G-ZQJR2HJPRW"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
export {analytics, logEvent}